module.exports = __webpack_public_path__ + "img/img-18.c07bce4c.png";